
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"100%","height":"100%","viewBox":"0 0 580.7 580.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M251.8 213.5v26.3h-26.7v43.5h26.7v131.2h43.1V283.3h43.3l6.8-43.5h-50.1V218c0-11.3 3.7-22.2 20-22.2h32.6v-43.4h-46.2c-38.9 0-49.5 25.6-49.5 61.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M495.8 85C440.9 30.2 368 0 290.4 0S139.9 30.2 85.1 85.1C30.3 139.9 0 212.9 0 290.4 0 368 30.2 440.9 85.1 495.7c54.8 54.8 127.8 85.1 205.3 85.1 77.6 0 150.5-30.2 205.3-85.1 54.8-54.8 85.1-127.8 85.1-205.3 0-77.6-30.2-150.5-85-205.4zM290.4 537.2c-136.1 0-246.8-110.7-246.8-246.8S154.3 43.5 290.4 43.5s246.8 110.7 246.8 246.8-110.7 246.9-246.8 246.9z"}})])
          )
        }
      }
    